const DRAUGHT_STATE = 1;
const TIDE_STATE = 2;
const SOUNDINGS_STATE = 3;

const DRAUGHT_LABEL = 'Draught';
const TIDE_LABEL = 'Tide';
const SOUNDINGS_LABEL = 'Soundings';

const FADE_IN_PREFIX = 'fade-in-';
const FADE_OUT_PREFIX = 'fade-out-';
const FADE_IN_BUTTONS_CSS_CLASS = `${FADE_IN_PREFIX}buttons`;
const FADE_IN_SLIDER_CSS_CLASS = `${FADE_IN_PREFIX}slider`;
const FADE_OUT_BUTTONS_CSS_CLASS = `${FADE_OUT_PREFIX}buttons`;
const FADE_OUT_SLIDER_CSS_CLASS = `${FADE_OUT_PREFIX}slider`;
const FADE_IN_DIV_BUTTON_CSS_CLASS = `${FADE_IN_PREFIX}div-bar`;
const FADE_OUT_DIV_BUTTON_CSS_CLASS = `${FADE_OUT_PREFIX}div-bar`;
const CONTROL_CSS_CLASS = 'ol-geomod-draught-tide';
const CONTROL_BAR_BUTTON_CSS_CLASS = 'bar-elmt';

const SAFETY_CONTOUR = 'SAFETY_CONTOUR';
const SAFETY_DEPTH = 'SAFETY_DEPTH';

export default {
  DRAUGHT_STATE,
  TIDE_STATE,
  SOUNDINGS_STATE,
  DRAUGHT_LABEL,
  TIDE_LABEL,
  SOUNDINGS_LABEL,
  FADE_IN_PREFIX,
  FADE_OUT_PREFIX,
  FADE_IN_BUTTONS_CSS_CLASS,
  FADE_IN_SLIDER_CSS_CLASS,
  FADE_OUT_BUTTONS_CSS_CLASS,
  FADE_OUT_SLIDER_CSS_CLASS,
  FADE_IN_DIV_BUTTON_CSS_CLASS,
  FADE_OUT_DIV_BUTTON_CSS_CLASS,
  CONTROL_CSS_CLASS,
  CONTROL_BAR_BUTTON_CSS_CLASS,
  SAFETY_CONTOUR,
  SAFETY_DEPTH
}